import { AuthContainer, AuthContainerSuccess } from "./ui";

export const Auth = {
    Container: AuthContainer,
    ContainerSuccess: AuthContainerSuccess
}